import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export const downloadUsersReport = (): Promise<void> =>
  occFetch(occUrl("/users_report")).then(downloadBlobFromResponse);
